const helper = {
  sessionStorageValue(name, defaultValue = null) {
    return sessionStorage.getItem(name) &&
      sessionStorage.getItem(name) !== 'undefined'
      ? JSON.parse(sessionStorage.getItem(name))
      : defaultValue
  },
}

const state = {
  enc: helper.sessionStorageValue('enc'),
  xid: helper.sessionStorageValue('xid'),

}
const getters = {
  getEnc: (state) => state.enc,
  getXid: (state) => state.xid,
}
const actions = {
  setEnc({ commit }, payload) {
    commit('SET_ENC', payload)
  },
  setXid({ commit }, payload) {
    commit('SET_XID', payload)
  },
}
const mutations = {
  SET_ENC(state, data) {
    state.enc = data
    sessionStorage.setItem('enc', JSON.stringify(data))
  },
  SET_XID(state, data) {
    state.xid = data
    sessionStorage.setItem('xid', JSON.stringify(data))
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
